import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";
import { designSystemIconPreview } from "../../components/DesignSystemIconInput";

export default defineType({
  title: "Micro Content Excursion Subcategories",
  name: "microContentExcursionSubCategories",
  type: "object",
  fields: [
    {
      name: "mxpCode",
      title: "MXP Code",
      type: "string"
    },
    {
      name: "code",
      title: "Display Code",
      type: "string",
    },
    {
      name: "label",
      title: "Label",
      type: "multilingualArrayString"
    },
    {
      name: "content",
      title: "Content",
      type: "multilingualArrayText"
    }
  ],
  preview: {
    select: {
      title: "label",
      code: "code"
    },
    prepare({ title, code }) {
      return {
        title: multilingualStringPreview(title),
        subtitle: code,
      };
    }
  }
});
